import Vue from "vue";
import { remove, shuffle } from 'lodash';
export default Vue.extend({
    name: 'customer-rotator',
    data() {
        return {
            all_customers: [
                {
                    name: 'axivas',
                    next: '',
                    animated: false
                },
                {
                    name: 'baxter',
                    next: '',
                    animated: false
                },
                {
                    name: 'circlon',
                    next: '',
                    animated: false
                },
                {
                    name: 'cofinpro',
                    next: '',
                    animated: false
                },
                {
                    name: 'deutscheboerse',
                    next: '',
                    animated: false
                },
                {
                    name: 'dsai',
                    next: '',
                    animated: false
                },
                {
                    name: 'emtechnik',
                    next: '',
                    animated: false
                },
                {
                    name: 'exner',
                    next: '',
                    animated: false
                },
                {
                    name: 'falk',
                    next: '',
                    animated: false
                },
                {
                    name: 'fiducia',
                    next: '',
                    animated: false
                },
                {
                    name: 'ibis',
                    next: '',
                    animated: false
                },
                {
                    name: 'isover',
                    next: '',
                    animated: false
                },
                {
                    name: 'iwm',
                    next: '',
                    animated: false
                },
                {
                    name: 'martinundkarch',
                    next: '',
                    animated: false
                },
                {
                    name: 'mlp',
                    next: '',
                    animated: false
                },
                {
                    name: 'mondo',
                    next: '',
                    animated: false
                },
                {
                    name: 'mwsp',
                    next: '',
                    animated: false
                },
                {
                    name: 'nrv',
                    next: '',
                    animated: false
                },
                {
                    name: 'pepperl+fuchs',
                    next: '',
                    animated: false
                },
                {
                    name: 'pfalzwerke',
                    next: '',
                    animated: false
                },
                {
                    name: 'pfizer',
                    next: '',
                    animated: false
                },
                {
                    name: 'rc',
                    next: '',
                    animated: false
                },
                {
                    name: 'redbull',
                    next: '',
                    animated: false
                },
                {
                    name: 'rhc',
                    next: '',
                    animated: false
                },
                {
                    name: 'riva',
                    next: '',
                    animated: false
                },
                {
                    name: 'soehnle',
                    next: '',
                    animated: false
                },
                {
                    name: 'stadtmarketing',
                    next: '',
                    animated: false
                },
                {
                    name: 'suedzucker',
                    next: '',
                    animated: false
                },
                {
                    name: 'visualvest',
                    next: '',
                    animated: false
                },
                {
                    name: 'vw',
                    next: '',
                    animated: false
                },
            ],
            reduced_customers: [],
            display_customers: [],
            gone_customers: [],
        };
    },
    mounted() {
        this.initDisplayCustomers();
        this.rotateCustomers();
    },
    methods: {
        initDisplayCustomers() {
            let shuffled = shuffle(this.all_customers);
            for (let i = 0; i <= 5; i++) {
                let customer = shuffled[1];
                remove(shuffled, (c) => {
                    return c.name === customer.name;
                });
                this.reduced_customers = shuffled;
                this.display_customers.push(customer);
            }
        },
        rotateCustomers() {
            let i = 0;
            setTimeout(() => {
                let index = this.removeCustomer();
                if (this.reduced_customers.length !== 0) {
                    let customer = this.reduced_customers[0];
                    this.display_customers.splice(index, 0, customer);
                    remove(this.reduced_customers, (c) => {
                        //@ts-ignore
                        return c.name === customer.name;
                    });
                }
                else {
                    this.reduced_customers = this.all_customers;
                }
                i++;
                if (i <= this.reduced_customers.length) {
                    this.rotateCustomers();
                }
                else {
                    this.display_customers = [];
                    this.initDisplayCustomers();
                    this.rotateCustomers();
                }
            }, 2000);
        },
        removeCustomer() {
            let index = Math.floor((Math.random() * this.display_customers.length - 1));
            this.display_customers.splice(index, 1);
            return index;
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./src/components/customer-rotator/customer-rotator.ts
// module id = null
// module chunks = 